<template>
    <g>
        <path d="M30,60c-0.553,0-1-0.448-1-1V1c0-0.552,0.447-1,1-1s1,0.448,1,1v58C31,59.552,30.553,60,30,60z" />
        <path
            d="M40,12c-0.256,0-0.512-0.098-0.707-0.293l-10-10c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l10,10c0.391,0.391,0.391,1.023,0,1.414C40.512,11.902,40.256,12,40,12z"
        />
        <path
            d="M20,12c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C20.512,11.902,20.256,12,20,12z"
        />
        <path
            d="M30,60c-0.256,0-0.512-0.098-0.707-0.293l-10-10c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l10,10c0.391,0.391,0.391,1.023,0,1.414C30.512,59.902,30.256,60,30,60z"
        />
        <path
            d="M30,60c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C30.512,59.902,30.256,60,30,60z"
        />
        <path d="M59,31H1c-0.553,0-1-0.448-1-1s0.447-1,1-1h58c0.553,0,1,0.448,1,1S59.553,31,59,31z" />
        <path
            d="M49,41c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C49.512,40.902,49.256,41,49,41z"
        />
        <path
            d="M59,31c-0.256,0-0.512-0.098-0.707-0.293l-10-10c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l10,10c0.391,0.391,0.391,1.023,0,1.414C59.512,30.902,59.256,31,59,31z"
        />
        <path
            d="M1,31c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l10-10 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-10,10C1.512,30.902,1.256,31,1,31z"
        />
        <path
            d="M11,41c-0.256,0-0.512-0.098-0.707-0.293l-10-10c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l10,10c0.391,0.391,0.391,1.023,0,1.414C11.512,40.902,11.256,41,11,41z"
        />
    </g>
</template>
